var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnComment = function SvgBtnComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.001 5.667a1.4 1.4 0 0 0-1.4 1.4V15.374l-.001.007v3.905c0 .031.008.047.015.057.01.013.025.027.047.036.022.009.043.01.058.007a.092.092 0 0 0 .051-.03l1.717-1.74H18a1.4 1.4 0 0 0 1.4-1.4v-9.15a1.4 1.4 0 0 0-1.4-1.4H7Zm-2.6 1.4a2.6 2.6 0 0 1 2.6-2.6H18a2.6 2.6 0 0 1 2.6 2.6v9.15a2.6 2.6 0 0 1-2.6 2.6H7.99l-1.365 1.382c-.816.828-2.225.25-2.225-.913v-3.905l.001-.055v-8.26Zm3.757 3.153a.6.6 0 0 1 .6-.6h7.484a.6.6 0 1 1 0 1.2H8.758a.6.6 0 0 1-.6-.6Zm.6 2.687a.6.6 0 1 0 0 1.2h7.484a.6.6 0 0 0 0-1.2H8.758Z",
    fill: "#7E8185"
  })));
};
export default SvgBtnComment;